import { SEM_TYPOGRAPHY_FORMS_APPENDIX, SEM_TYPOGRAPHY_FORMS_INPUT, SEM_TYPOGRAPHY_FORMS_LABEL, SEM_TYPOGRAPHY_FORMS_LABEL_SMALL } from '../../tokens/typography.generated.js';
import { getTypographyStyles } from '../../utils/index.js';
import styled from 'styled-components';
import { FormMessage } from '../form-message/index.js';
import { SYS_SPACE_FIXED_100, SYS_SPACE_FIXED_150, SYS_SPACE_FIXED_250 } from '../../tokens/spacing.generated.js';
import { Icon } from '../icon/index.js';
import { SYS_SIZE_FIXED_1400, SYS_SIZE_FIXED_50, SYS_SIZE_FIXED_600 } from '../../tokens/sizing.generated.js';
import { SEM_BORDER_WIDTH_FORMS_ACTIVE, SEM_BORDER_WIDTH_FORMS_DEFAULT } from '../../tokens/border-width.generated.js';
const underlineContainerHeight = SYS_SIZE_FIXED_50;
const iconWidth = SYS_SIZE_FIXED_600;
const iconHeight = iconWidth;
const inputMinHeight = `calc(${SYS_SIZE_FIXED_1400} - ${SYS_SPACE_FIXED_250} + ${underlineContainerHeight})`;
const labelLineHeight = SEM_TYPOGRAPHY_FORMS_LABEL.lineHeight;
const labelTopPositioning = `calc(${SYS_SPACE_FIXED_250} + ((${inputMinHeight} - ${labelLineHeight}) / 2))`;
const iconTopPositioning = `calc(${SYS_SPACE_FIXED_250} + ((${inputMinHeight} - ${iconHeight}) / 2))`;
const underlineTopPositioningDefault = `calc(${SYS_SIZE_FIXED_1400} + ${SEM_BORDER_WIDTH_FORMS_DEFAULT})`;
const underlineTopPositioningActive = SYS_SIZE_FIXED_1400;
export const StyledLabel = styled.label `
  display: flex;
  gap: ${SYS_SPACE_FIXED_100};
  justify-content: start;
  align-items: flex-end;
  position: absolute;
  pointer-events: none;
  // TODO: get motion tokens
  transition: all 0.2s ease;
  top: ${(props) => (props.value ? '0px' : labelTopPositioning)};
  left: ${(props) => props.value || !props.icon
    ? '0px'
    : `calc(${iconWidth} + ${SYS_SPACE_FIXED_150})`};

  ${(props) => props.value
    ? getTypographyStyles(SEM_TYPOGRAPHY_FORMS_LABEL_SMALL)
    : getTypographyStyles(SEM_TYPOGRAPHY_FORMS_LABEL)};

  color: ${(props) => props.disabled
    ? props.theme.sem.color.forms.foreground.text.disabled
    : props.invalid
        ? props.theme.sem.color.forms.foreground.text.error
        : props.theme.sem.color.forms.foreground.text.default};
`;
export const StyledUnderline = styled.hr `
  height: ${SEM_BORDER_WIDTH_FORMS_DEFAULT};
  border: none;
  width: 100%;
  margin: 0;
  appearance: none;
  // TODO: Get motion tokens
  transition: all 0.2s ease;
  position: absolute;
  top: ${underlineTopPositioningDefault};
  background-color: ${(props) => props.disabled
    ? props.theme.sem.color.forms.surface.underline.stroke.disabled
    : props.invalid
        ? props.theme.sem.color.forms.surface.underline.stroke.error
        : props.theme.sem.color.forms.surface.underline.stroke.default};
`;
export const StyledSelect = styled.select `
  background-color: transparent;
  border: none;
  width: 100%;
  appearance: none;
  ${getTypographyStyles(SEM_TYPOGRAPHY_FORMS_INPUT)}
  margin-top: ${SYS_SPACE_FIXED_250};
  min-height: ${inputMinHeight};
  padding: 0 0 0
    ${(props) => props.icon ? `calc(${iconWidth} + ${SYS_SPACE_FIXED_150})` : '0px'};
  opacity: ${(props) => (props.empty ? 0 : 1)};
  color: ${(props) => props.disabled
    ? props.theme.sem.color.forms.foreground.text.disabled
    : props.theme.sem.color.forms.foreground.text.default};

  &:hover:enabled {
    color: ${(props) => props.theme.sem.color.forms.foreground.text.interactive};

    & + ${StyledLabel} {
      color: ${(props) => props.invalid
    ? props.theme.sem.color.forms.foreground.text.error
    : props.theme.sem.color.forms.foreground.text.interactive};
    }

    & ~ ${StyledUnderline} {
      background-color: ${(props) => props.invalid
    ? props.theme.sem.color.forms.surface.underline.stroke.error
    : props.theme.sem.color.forms.surface.underline.stroke.interactive};
    }
  }

  &:focus,
  &:active:not(:disabled) {
    & + ${StyledLabel} {
      top: 0px;
      left: 0px;
      opacity: 1;
      ${getTypographyStyles(SEM_TYPOGRAPHY_FORMS_LABEL_SMALL)};
    }
    & ~ .arrow {
      transform: rotateZ(180deg);
    }

    & ~ ${StyledUnderline} {
      background-color: ${(props) => props.invalid
    ? props.theme.sem.color.forms.surface.underline.stroke.error
    : props.theme.sem.color.forms.surface.underline.stroke.interactive};
      height: ${(props) => props.disabled
    ? SEM_BORDER_WIDTH_FORMS_DEFAULT
    : SEM_BORDER_WIDTH_FORMS_ACTIVE};
      top: ${underlineTopPositioningActive};
    }
  }
`;
export const StyledOuterContainer = styled.div `
  display: flex;
  flex-direction: column;
  position: relative;
`;
export const StyledFormMessage = styled(FormMessage) `
  padding-top: ${SYS_SPACE_FIXED_150};
`;
export const StyledAppendix = styled.span `
  color: ${(props) => props.theme.sem.color.forms.foreground.text.caption};
  ${getTypographyStyles(SEM_TYPOGRAPHY_FORMS_APPENDIX)};
`;
export const StyledIcon = styled(Icon) `
  flex-shrink: 0;
  transition: all 0.2s ease;
  pointer-events: none;
  position: absolute;
  top: ${iconTopPositioning};
  color: ${(props) => props.disabled
    ? props.theme.sem.color.forms.foreground.icons.disabled
    : props.invalid
        ? props.theme.sem.color.forms.foreground.icons.error
        : props.theme.sem.color.forms.foreground.icons.default};

  & + ${StyledSelect}:hover:enabled {
    color: ${(props) => !props.invalid &&
    props.theme.sem.color.forms.foreground.icons.interactive};
  }

  &.leading {
    left: 0;
  }

  &.arrow {
    right: 0;
  }
`;
//# sourceMappingURL=index.styles.js.map